import ageLimits from './ageLimits';
import countries from './countries';
import distributors from './distributors';
import laboratories from './laboratories';
import movies from './movies';
import formats from './formats';
import genres from './genres';

export default {
  namespaced: true,

  modules: {
    ageLimits,
    countries,
    laboratories,
    distributors,
    movies,
    formats,
    genres,
  },
};
